module.exports = __webpack_public_path__ + "media/application/images/university-leiden-logo-af59b1e0a542351c7a35521e4955a699.svg";